import basicFlow from "./asyncHandler";
import { put, select, takeEvery } from "redux-saga/effects";
import { actions, types } from "../reducers/rastreamento.actions";
import { authenticatedRequest } from "../utils/api";
import { routeWatcher } from "./rotas.saga";
import { types as routes } from "../reducers/rotas.actions";
import { getFiltros } from "../selectors/rastreamento.selectors";
import formatters from "../utils/formatters";
import { getUsuario } from "../selectors/usuario.selectors";

const pesquisar = basicFlow({
  actionGenerator: actions.pesquisar,
  transform: function* () {
    const currentFilter = yield select(getFiltros);
    const usuario = yield select(getUsuario);
    const empresa = currentFilter.empresa?.id
      ? currentFilter.empresa?.id
      : !!usuario?.empresa
      ? usuario.empresa
      : currentFilter.empresa?.id;

    return {
      empresa,
      roteiros: currentFilter.roteiros.map((r) => r.id).join(","),
      inicioPeriodo: formatters.dates.revert(currentFilter.inicioPeriodo),
      fimPeriodo: formatters.dates.revert(currentFilter.fimPeriodo),
    };
  },
  api: (values) => {
    return authenticatedRequest({
      url: `/rastreamento/posicoes`,
      method: "get",
      queryParams: values,
    });
  },
});

const carregarEmpresas = basicFlow({
  actionGenerator: actions.carregarEmpresas,
  api: (values) => {
    return authenticatedRequest({
      url: `/cliente/dominio?cliente=${values?.cliente ?? "false"}`,
      method: "get",
    });
  },
});

const carregarRoteiros = basicFlow({
  actionGenerator: actions.carregarRoteiros,
  api: (values) => {
    return authenticatedRequest({
      url: `/roteiro/dominio?empresa=${values.empresa}`,
      method: "get",
    });
  },
});

function* atualizarFiltrosWatcher() {
  yield takeEvery(types.ATUALIZAR_FILTROS, function* () {
    const currentFilter = yield select(getFiltros);
    if (
      currentFilter.empresa &&
      currentFilter.inicioPeriodo &&
      currentFilter.fimPeriodo
    ) {
      yield put(actions.pesquisar.request());
    }
  });
}

function* rastreamentoRouteWatcher() {
  yield routeWatcher(routes.RASTREAMENTO, function* () {
    const currentFilter = yield select(getFiltros);
    const usuario = yield select(getUsuario);

    if (!usuario?.empresa) {
      yield put(actions.carregarEmpresas.request());
    } else {
      yield put(
        actions.carregarEmpresas.request({ cliente: usuario?.empresa })
      );
      yield put(
        actions.atualizarFiltros({
          ...currentFilter,
          empresa: usuario.empresa,
          empresaNome: usuario.empresaNome,
        })
      );
    }

    if (!currentFilter.inicioPeriodo || !currentFilter.fimPeriodo) {
      const hoje = new Date();
      const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      yield put(
        actions.atualizarFiltros({
          inicioPeriodo: formatters.dates.short(inicioMes),
          fimPeriodo: formatters.dates.short(hoje),
        })
      );
    }
  });
}

export const sagas = [
  pesquisar.watcher(),
  carregarEmpresas.watcher(),
  carregarRoteiros.watcher(),
  atualizarFiltrosWatcher(),
  rastreamentoRouteWatcher(),
];
